import React from 'react';
import { Switch, Route } from 'react-router-dom';
import App from '../components/App';
import CallbackPage from '../components/login/callbackPage';
import UploadDocuments from 'features/document/edit/documents/components/UploadDocuments';
import LoginPage from 'components/login/loginPage';

export default (
  <Switch>
    <Route exact path='/callback' component={CallbackPage} />
    <Route exact path='/login' component={LoginPage} />
    <Route exact path='/upload/:documentId(\d+)/:siteId(\d+)' component={UploadDocuments} />
    <Route path='' component={App} />
  </Switch>
);
